import React, { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Box, Divider, ListItemIcon, Typography } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { addToDictionary } from "../store/slices/dictionary/addToDictionarySlice";
import { useDispatch } from "react-redux";

function AddToDictionaryMenu({
  selectedWord,
  menuPosition,
  setShowMenu,
  content,
  setContent,
  type,
  // handleHighlightWord,
}) {
  const dispatch = useDispatch();

  const isSingleWord = !selectedWord.includes(" ");
  const handleAddToDictionary = () => {
    if (selectedWord) {
      dispatch(addToDictionary(selectedWord));
    }
    setShowMenu(false); // Hide the menu after adding
  };

  const handleHighlightWord = () => {
    if (selectedWord && content) {
      let highlightedContent;

      if (selectedWord.includes(" ")) {
        // If multiple words are selected, use exact match for replacement
        highlightedContent = content.replace(
          selectedWord,
          `<span style="background-color:#fddd0a42;padding:2px;">${selectedWord}</span>`
        );
      } else {
        // If a single word is selected, match as a whole word
        highlightedContent = content.replace(
          new RegExp(`\\b${selectedWord}\\b`, "g"), // Match whole word
          `<span style="background-color:#fddd0a42;  padding:2px;">${selectedWord}</span>`
        );
      }
      // Set the content with the highlighted text
      setContent(highlightedContent);

      // Optionally, close the menu
      setShowMenu(false);
    }
  };

  const handleHighlightMarkdownWord = () => {
    if (selectedWord && content) {
      let highlightedContent;

      if (selectedWord.includes(" ")) {
        // For multi-word selections, replace the exact match
        highlightedContent = content.replace(
          selectedWord,
          `==${selectedWord}==` // Wrap the selected text in Markdown-style highlighting
        );
      } else {
        // For single-word selections, use a word boundary regex to replace whole words only
        highlightedContent = content.replace(
          new RegExp(`\\b${selectedWord}\\b`, "g"),
          `==${selectedWord}==`
        );
      }

      // Update the content state with the highlighted text
      setContent(highlightedContent);

      // Optionally, close the menu after highlighting
      setShowMenu(false);
    }
  };

  // const handleUndoHighlight = () => {
  //   if (content) {
  //     // Remove the <span> tags and retain the inner text
  //     const unhighlightedContent = content.replace(
  //       /<span style="[^"]*">(.*?)<\/span>/g,
  //       "$1"
  //     );

  //     // Set the content back to its unhighlighted state
  //     setContent(unhighlightedContent);

  //     // Optionally, close the menu
  //     setShowMenu(false);
  //   }
  // };

  useEffect(() => {
    const handleScroll = () => {
      setShowMenu(false); // Hide menu when page is scrolled
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up on unmount
    };
  }, [setShowMenu]);

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: menuPosition.y + 10,
          left: Math.min(menuPosition.x, window.innerWidth - 280),
          background:
            "linear-gradient(135deg,rgb(235, 248, 254),rgb(249, 249, 249))", // Light blue gradient
          borderRadius: "10px",
          boxShadow: "0px 4px 12px rgba(42, 42, 42, 0.24)", // Soft shadow
          zIndex: 999,
          // padding: "5px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "270px",
          border: "1px solid rgba(199, 199, 199, 0.72)", // Light border
          // position: "relative", // Needed for the arrow
          // "&::before": {
          //   content: '""',
          //   position: "absolute",
          //   top: "-10px",
          //   left: "15px",
          //   width: "0",
          //   height: "0",
          //   // marginBottom:'-15px',
          //   borderLeft: "10px solid transparent",
          //   borderRight: "10px solid transparent",
          //   borderBottom: "10px solid rgb(190, 190, 190)", // Matches menu background
          // },
        }}
      >
        {isSingleWord && (
          <>
            <Typography
              variant="body2"
              sx={{
                padding: "10px",
                cursor: "pointer",
                color: "#2c3e50", // Dark blue-gray text
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                borderRadius: "6px",
                transition: "background 0.3s",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, rgb(244, 244, 244), rgb(237, 250, 255))", // Light blue hover
                },
                width: "100%",
              }}
              onClick={handleAddToDictionary}
            >
              <ListItemIcon sx={{ minWidth: "30px", color: "#007bff" }}>
                <PlaylistAddIcon fontSize="small" sx={{ fontSize: "22px" }} />
              </ListItemIcon>
              Add "{selectedWord}" to Dictionary
            </Typography>
            <Divider
              sx={{ width: "100%", backgroundColor: "rgb(231, 231, 231)" }}
            />
          </>
        )}
        <Typography
          variant="body2"
          sx={{
            padding: "10px",
            cursor: "pointer",
            color: "#2c3e50",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            borderRadius: "6px",
            transition: "background 0.3s",
            "&:hover": {
              background:
                "linear-gradient(135deg, rgb(244, 244, 244), rgb(230, 246, 253))", // Light peach hover
            },
            width: "100%",
          }}
          onClick={() => {
            if (type === "markdown") {
              handleHighlightMarkdownWord();
            } else {
              handleHighlightWord();
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: "30px", color: "#ff7300" }}>
            <BorderColorIcon fontSize="small" sx={{ fontSize: "17px" }} />
          </ListItemIcon>
          Highlight the text
        </Typography>
      </Box>
    </>
  );
}

export default AddToDictionaryMenu;
